<template>
  <div>
    <layout-one>
      <div>
        <div><span>综合课程名称：</span>{{ nowCourseName }}</div>
      </div>
      <div>
        <div><span>综合课通过分数：</span>大于等于{{ corusePassScore }}分</div>
      </div>
      <div class="sectionBox">        
        <span>选择单科：</span>
        <div class="stationBox">
            <!-- 快捷搜索功能 -->
            <div class="stationTop">
                <div class="searchCourse">
                    <el-input placeholder="快捷搜索" v-model="courseStr"></el-input>
                    <div class="searchPos">
                        <i class="iconfont icon-sousuo"></i>
                    </div>
                </div>
            </div>
            <!-- 课程全选 -->
            <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
            >全选</el-checkbox>
            <!-- 课程勾选 -->
            <el-checkbox-group
                v-model="courseIdList"
                @change="handleCheckedChange"
            >
                <el-checkbox
                v-for="course in courseSelectData"
                :label="course.id"
                :key="course.id"
                :title="course.name"
                >{{ course.name }}</el-checkbox>
            </el-checkbox-group>
        </div>
      </div>
      <div class="sectionBox" v-if="checkedCourseInfo.length">
        <span>单科设置：</span>
        <div class="stationBox">
          <div v-for="course in checkedCourseInfo" :key="course.id">
            <span class="specialSpanTitle">
              {{ course.name }}：
            </span>
            <span class="specialSpanContent">
              成绩计算方式：
              <el-select v-model="course.scoreCalculateType" placeholder="请选择">
                <el-option label="原始成绩" :value="1"></el-option>
                <el-option label="赋分后成绩" :value="2"></el-option>
              </el-select>                
            </span>
            <span class="specialSpanContent">
              通过分数线：&gt;=
              <el-input 
                v-model.number ="course.passScore" 
                placeholder="请输入" 
                maxlength="3">
              </el-input> 分
            </span>
            
          </div>
        </div>        
      </div>
      <div class="btnClass">
        <el-button round @click="$router.go(-1)">取消</el-button>
        <el-button type="primary" @click="addSubCourse" round>确定</el-button>
      </div>
    </layout-one>
  </div>
</template>
<script>
import { getSingleCourse,getCourseSubListFn, addCourseSubFn,getCourseSubAllFn} from '@/http/modules/baseSet/course'
export default {
  name: "addSubCourse",
  data() {
    return {
      nowCourseName: this.$route.query.courseName,
      coruseScoreCalculateType : "",
      corusePassScore : "",
      // 快捷搜索
      courseStr: "",
      courseData: [],
      // 全选样式
      isIndeterminate: true, 
      // 是否全选
      checkAll: false,
      courseIdList: [],
      checkedCourseInfo: [],
    };
  },
  created() {
    this.initData();
  },
  computed: {
    courseSelectData() {
      return this.courseStr ? this.courseData.filter((item) => item.name.indexOf(this.courseStr) > -1): this.courseData;
    },
  },
  methods: {
    async initData() {
      //拿到所有课程信息
      const { code : courseCode,data : courseData } = await getSingleCourse({id : this.$route.query.courseId});
      if(courseCode === 1){
        this.coruseScoreCalculateType = courseData.scoreCalculateType;
        this.corusePassScore = courseData.passScore;
      }
      const { code,data } = await getCourseSubAllFn();
      if(code === 1){
        //根据已经保存的数据更新各种状态
        const res = await getCourseSubListFn({ courseId: this.$route.query.courseId });
        if (res.code === 1) {
          this.courseIdList = res.data.map((item) => item.subCourseId);
          this.checkedCourseInfo = data
            .filter(course => this.courseIdList.includes(course.id))
            .map(course => {
              const editData = res.data.find(item => item.subCourseId === course.id);
              return {
                id : course.id,
                name: course.name,
                scoreCalculateType: editData ? (editData.scoreCalculateType ?? '') : '',
                passScore: editData ? (editData.passScore ?? '') : ''
              };
            });
          this.checkAll = this.courseIdList.length === data.length;
          this.isIndeterminate = this.courseIdList.length > 0 && !this.checkAll;
          //把data里的passScore更新成res.data里的passScore
          this.courseData = data.map(course => {
            const editData = res.data.find(item => item.subCourseId === course.id);
            return {
              id : course.id,
              name: course.name,
              scoreCalculateType: editData ? (editData.scoreCalculateType ?? '') : '',
              passScore: editData ? (editData.passScore ?? '') : ''
            };
          });
        }else{
          this.courseData = data;
        }
      }
    },
    handleCheckAllChange(val) {
      this.isIndeterminate = false;
      this.courseIdList = val ? this.courseSelectData.map((item) => item.id): [];
      if (val) {
        this.checkedCourseInfo = this.courseSelectData
            .map(course => {
              const tmpScore = this.checkedCourseInfo.find(item => item.id === course.id);
              return {
                ...course,
                passScore: tmpScore != null ? tmpScore.passScore : course.passScore != null ? course.passScore : '',
                scoreCalculateType: tmpScore != null ? tmpScore.scoreCalculateType : course.scoreCalculateType != null ? course.scoreCalculateType : ''
              };
            });
      }else{
        this.checkedCourseInfo = [];
      }
    },
    handleCheckedChange(value) {
      this.checkAll = value.length == this.courseSelectData.length && this.courseSelectData.length > 0;
      this.isIndeterminate = value.length > 0 && value.length < this.courseSelectData.length;
      this.checkedCourseInfo = this.courseData
        .filter(course => value.includes(course.id))
        .map(course => {
          const tmpScore = this.checkedCourseInfo.find(item => item.id === course.id);
          return {
            ...course,
            passScore: tmpScore != null ? tmpScore.passScore : course.passScore != null ? course.passScore : '',
            scoreCalculateType: tmpScore != null ? tmpScore.scoreCalculateType : course.scoreCalculateType != null ? course.scoreCalculateType : ''
          };
        });
    },
    async addSubCourse() {
      // 验证成绩计算方式是否填写
      const hasEmptyScoreCalculateType = this.checkedCourseInfo.some(course => {
        const scoreCalculate = course.scoreCalculateType;
        return scoreCalculate === '' || scoreCalculate === null;  
      });
      if(hasEmptyScoreCalculateType){
        this.$message.error('请选择所有选中课程的成绩计算方式');
        return;
      }
      // 验证分数是否填写
      const hasEmptyScore = this.checkedCourseInfo.some(course => {
        const score = course.passScore;
        return typeof score !== 'number' || score < 0 || !Number.isInteger(score);
      });
      if (hasEmptyScore) {
        this.$message.error('请填写所有选中课程的通过分数线，且必须为大于等于0的整数');
        return;
      }
      // 验证分数是否为数字
      const hasInvalidScore = this.checkedCourseInfo.some(course => isNaN(course.passScore));
      if (hasInvalidScore) {
        this.$message.error('请填写正确的通过分数线');
        return;
      }
      //准备提交的数据
      const courseSubInfo = this.checkedCourseInfo.map(course => `${course.id}#${course.passScore}#${course.scoreCalculateType}`).join(',');
      try {
        const courseId = this.$route.query.courseId;
        const res = await addCourseSubFn({
            courseId : courseId,
            courseSubInfo: courseSubInfo
        });
        if (res.code === 1) {
          this.$message.success('设置成功');
          this.$router.go(-1);
        } else {
          this.$message.error('设置失败');
        }
      } catch (error) {
        this.$message.error('提交失败');
      }
    },
  },
};
</script>
<style lang="less" scoped>
div {
  margin-bottom: 20px;
  span {
    width: 155px;
    display: inline-block;
    text-align: right;
    font-weight: bold;
    color:#707175;
  }
  .specialSpanTitle{
    width: 180px;
    display: inline-block;
    text-align: left ;
    font-weight: bolder;
    border: #707175 solid 0px;
  }
  .specialSpanContent{
    width: 370px;
    display: inline-block;
    text-align: left ;
    font-weight: normal;
    border: #707175 solid 0px;
  }
  i {
    margin-left: 5px;
  }
  .courseName {
    width: 200px;
    text-align: left;
  }
}
.el-checkbox {
    width: 300px;
    overflow: hidden;
    white-space: nowrap;
    line-height: 38px;
}
.sectionBox{
    display: flex;
}
.stationBox {
    width: 1000px;
    max-height: 300px;
    background-color: #f8f9fc;
    overflow-y: auto;
    padding: 20px 70px;
    border-radius: 8px;
    .stationTop {
        display: flex;
        margin: 0px;
    }
    .searchCourse {
        position: relative;
        margin: 0px;
        .searchPos {
            width: 40px;
            height: 18px;
            line-height: 18px;
            border-left: 1px solid #e1e6ed;
            position: absolute;
            right: 0;
            top: 11px;
            color: #c2c6cc;
            font-size: 14px;
            i {
                margin-left: 10px;
                cursor: pointer;
            }
        }
    }
}
.btnClass {
    margin-left: 200px;
}
</style>